<template>
  <div>
    <el-drawer v-loading="loading" title="销售订单" :visible.sync="show" size="90%" :before-close="handleClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :disabled="type == '查看'|| isRejectTo" :model="form" :rules="rules" label-width="130px">

        <el-card header="基础信息">
          <el-row style="display: flex;flex-wrap: wrap;">
            <el-col :span="6">
              <el-form-item label="销售订单号">
                <el-input v-model="form.sn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="SAP销售单号">
                <el-input v-model="form.sapOrderSn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据类型" prop="salesCode">
                <el-select v-model="form.salesCode" :disabled="isDisabled" placeholder="请选择" @change="changeSalesType">
                  <el-option v-for="item in salesTypeOptions" :key="item.code" :label="item.name" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="销售组织" prop="salesOrganizationId">
                <el-select v-model="form.salesOrganizationId" :disabled="isDisabled"
                  @change="getOptionOrganization(form.salesOrganizationId)">
                  <el-option v-for="item in salesOrganizationOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="分销渠道" prop="channelOfDistributionId">
                <el-select v-model="form.channelOfDistributionId" :disabled="isDisabled"
                  @change="getProductTeamOption(form.channelOfDistributionId)">
                  <el-option v-for="item in channelDistributioOption" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品组" prop="productTeamId">
                <el-select v-model="form.productTeamId" :disabled="isDisabled">
                  <el-option v-for="item in productTeamOption" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="业务类型" prop="businessTypeId">
                <el-select v-model="form.businessTypeId" placeholder="请选择">
                  <el-option v-for="item in businessTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="售达方" prop="soldToPartyName">
                <el-input v-model="form.soldToPartyName" readonly placeholder="请点击图标选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectSoldToParty" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="送达方" prop="deliverySideName">
                <el-input v-model="form.deliverySideName" readonly placeholder="请点击图标选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectDeliverySide" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据状态" prop="status">
                <el-input v-model="statusArr[form.status]" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="交货工厂" prop="factoryId">
                <el-select v-model="form.factoryId" placeholder="请选择">
                  <el-option v-for="item in factoryOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="中间公司" prop="middleCompanyId"
                :rules="form.isVatRetreat == 1 ? [{ required: true, message: '请选择中间公司', trigger: 'change' }] : []">
                <el-input v-model="form.middleCompanyName" readonly placeholder="请点击图标选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectMiddleCompany" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单总金额(含税)">
                <el-input v-model="form.totalOrderAmount" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人">
                <el-input v-model="form.createUser" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间">
                <el-input v-model="form.createTime" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <el-checkbox v-model="form.isVatRetreat" :true-label="1" :false-label="0">退征即退</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-model="form.note" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据日期" prop="orderTime">
                <el-date-picker v-model="form.orderTime" type="datetime" placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="来源订单" prop="sourceOrderSn">
                <el-input v-model="form.sourceOrderSn" readonly placeholder="请点击图标选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectSourceOrder" />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="ZP03投入总重量">
                <el-input v-model="form.sumWeight" :disabled="true" placeholder="审核后自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="跟单员" prop="orderFollower">
                <el-input v-model="form.orderFollower" readonly placeholder="请选择">
                  <el-button slot="append" icon="el-icon-search" @click="selectOrderFollower" />
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card header="附件信息">
          <el-row>
            <FileUpload :file-type="['png', 'jpg', 'jpeg','doc','xls','pdf','xlsx','docx']"
              :value.sync="form.crmSalesOrdersAccessoryModels" :show-delect="form.status <= 1 || form.status==null " />
          </el-row>
        </el-card>
        <el-card header="订单明细">
          <el-tabs v-model="activePaneName">
            <el-tab-pane label="配件" name="mountings" v-if="form.salesCode === 'ZOR2'">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addSourceMountingsLine()">来源订单明细</el-button>
                <el-button type="primary" @click="addMountingsLine()">新增</el-button>
                <el-button type="primary" @click="addCommonsLine()">新增通用物料</el-button>
                <el-button type="danger" @click="delectMountingsLine()">一键清空配件列表</el-button>
                <excel-import :is-download-template="false" template-name="CrmSalesLineDataImport.xlsx"
                  url="/crm/sales/line/excelImport" template="CrmSalesLineDataImport.xlsx"
                  class-name="CrmSalesLineDataImport" title="导入" @resdata="getMountingsLine" />
                <el-button type="primary" style="margin-left: 5px;"
                  @click="handleMountingsLineTemplateDownload()">下载模版</el-button>
              </div>
              <el-table v-if="!showObj.mountings" ref="mountingsTable" height="400px" :data="form.mountingsList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.qty'
                      " :rules="mountingsList.qty">
                      <el-input v-model="scope.row.qty" placeholder="请输入" min="0" type="number"
                        @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="是否需要采购" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="isPurchase">
                      <el-switch v-model="scope.row.isPurchase" :disabled="true" active-text="是" inactive-text="否" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="拆解类型" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="separateType">
                      <el-select v-model="scope.row.separateType"
                        @change="setSeparateType(scope.row.separateType,scope.$index)">
                        <el-option v-for="item in separateTypeOption" :key="item.code" :label="item.name"
                          :value="item.code" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'mountingsList.' + scope.$index + '.taxPrice'
                      " :rules="mountingsList.taxPrice">
                      <el-input v-model="scope.row.taxPrice" placeholder="请输入" min="0" type="number"
                        @input="restrictNum(scope.row)" @blur="sumLordDutyPrice(scope.row,scope.$index,'mountings')" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="终端含税价格" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="terminalPriceIncludingTax">
                      <el-input v-model="scope.row.terminalPriceIncludingTax" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="终端含税金额" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="terminalTaxIncludedAmount">
                      <el-input v-model="scope.row.terminalTaxIncludedAmount" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="OE" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车辆ID" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carId">
                      <el-input v-model="scope.row.carId" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carNo">
                      <el-input v-model="scope.row.carNo" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="brand">
                      <el-input v-model="scope.row.brand" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车系" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="series">
                      <el-input v-model="scope.row.series" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="年款" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="modelYear">
                      <el-input v-model="scope.row.modelYear" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发动机型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="engineModel">
                      <el-input v-model="scope.row.engineModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="变速箱型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="transmissionModel">
                      <el-input v-model="scope.row.transmissionModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="排量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="displacement">
                      <el-input v-model="scope.row.displacement" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleMountingsDelete(scope.$index)">删除</el-button>
                    <span v-if="scope.row.isPurchase" class="blueBtn"
                      @click="setPurchase(scope.row,scope.$index)">采购信息</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="废料" name="flotsam" v-if="form.salesCode === 'ZOR1'">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addSourceFlotsamLine()">来源订单明细</el-button>
                <el-button type="primary" @click="addFlotsamLine()">新增</el-button>
                <el-button type="danger" @click="delectFlotsamLine()">一键清空废料列表</el-button>
              </div>
              <el-table v-if="!showObj.flotsam" ref="flotsamTable" height="400px" :data="form.flotsamList" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="拆解类型" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="separateType">
                      <el-select v-model="scope.row.separateType" @change="setSeparateType(scope.row.separateType,scope.$index)">
                        <el-option v-for="item in separateTypeOption" :key="item.code" :label="item.name" :value="item.code" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="是否返还" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="isPawhetherToReturnrts">
                      <el-select v-model="scope.row.whetherToReturn" placeholder="请选择">
                        <el-option v-for="item in whetherToReturnOptions" :key="item.value" :label="item.label"
                          :value="item.value" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column label="订单数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="'flotsamList.' + scope.$index + '.qty' " :rules="flotsamList.qty">
                      <el-input v-model="scope.row.qty" min="0" placeholder="请输入" type="number"
                        @blur="sumLordDutyPrice(scope.row,scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="市场价格" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="referencePrice">
                      <el-input v-model="scope.row.referencePrice" :disabled="true" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税单价" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="'flotsamList.' + scope.$index + '.taxPrice' " :rules="flotsamList.taxPrice">
                      <el-input v-model.number="scope.row.taxPrice" placeholder="请输入" type="number"
                        @input="restrictNum(scope.row)" @blur="sumLordDutyPrice(scope.row,scope.$index)" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税单价" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="taxExclusiveUnitPrice">
                      <el-input v-model="scope.row.taxExclusiveUnitPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="终端含税价格" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="terminalPriceIncludingTax">
                      <el-input v-model="scope.row.terminalPriceIncludingTax" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lordDutyPrice">
                      <el-input v-model="scope.row.lordDutyPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="终端含税金额" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="terminalTaxIncludedAmount">
                      <el-input v-model="scope.row.terminalTaxIncludedAmount" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="不含税金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="taxlessPrice">
                      <el-input v-model="scope.row.taxlessPrice" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="是否配件" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="isParts">
                      <el-select v-model="scope.row.isParts" placeholder="请选择">
                        <el-option v-for="item in isPartsOptions" :key="item.value" :label="item.label"
                          :value="item.value" />
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column v-if="false" label="扣杂金额" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="deductionAmount">
                      <el-input v-model="scope.row.deductionAmount"  placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>

                <el-table-column label="产值差异原因" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="lowPriceReason">
                      <el-select v-model="scope.row.lowPriceReason" placeholder="请选择">
                        <el-option v-for="item in lowPriceReasons" :key="item.value" :label="item.label"
                          :value="item.value"/>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="产值差异图片" align="left" show-overflow-tooltip width="260">
                  <template slot-scope="scope">
                    <el-form-item prop="fileList">
                      <UploadPicture :file-type="['png', 'jpg', 'jpeg']" :show-delect="true" :reference-id="scope.row.id" 
                        :reference-table="'crm_sales_orders_line'" :attribute1="'扣杂凭证'"/>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleFlotsamDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="ZP03投入" name="putIntoZP03">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addPutIntoZP03Line()">新增</el-button>
                <el-button type="danger" @click="delectPutIntoZP03Line()">一键清空散件列表</el-button>
                <excel-import :is-download-template="false" template-name="CrmSalesLineDataImport.xlsx"
                  url="/crm/sales/line/excelImports" template="CrmSalesLineDataImport.xlsx"
                  class-name="CrmSalesLineDataImport" title="导入" @resdata="getPutIntoZP03Line" />
                <el-button type="primary" style="margin-left: 5px;"
                  @click="handlePutIntoZP03LineTemplateDownload()">下载模版</el-button>
              </div>
              <el-table v-if="!showObj.putIntoZP03" ref="putIntoZP03Table" height="400px" :data="form.putIntoZP03"
                border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="'putIntoZP03.' + scope.$index + '.qty' " :rules="putIntoZP03.qty">
                      <el-input v-model="scope.row.qty" min="0" placeholder="请输入" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单价" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item :prop="'putIntoZP03.' + scope.$index + '.price' " :rules="putIntoZP03.price">
                      <el-input v-model="scope.row.price" min="0" placeholder="请输入" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="OE" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="重量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="weight">
                      <el-input v-model="scope.row.weight" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车辆ID" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carId">
                      <el-input v-model="scope.row.carId" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carNo">
                      <el-input v-model="scope.row.carNo" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="brand">
                      <el-input v-model="scope.row.brand" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车系" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="series">
                      <el-input v-model="scope.row.series" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="年款" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="modelYear">
                      <el-input v-model="scope.row.modelYear" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发动机型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="engineModel">
                      <el-input v-model="scope.row.engineModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="变速箱型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="transmissionModel">
                      <el-input v-model="scope.row.transmissionModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="排量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="displacement">
                      <el-input v-model="scope.row.displacement" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handlePutIntoZP03Delete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <!-- <el-tab-pane label="ZP09投入" name="putIntoZP09">
              <div style="margin-bottom: 10px;display: flex;justify-content: flex-end;">
                <el-button type="primary" @click="addPutIntoZP09Line()">新增</el-button>
                <el-button type="danger" @click="delectPutIntoZP09Line()">一键清空散件列表</el-button>
                <excel-import :is-download-template="false" template-name="CrmSalesLineDataImport.xlsx" url="/crm/sales/line/excelImports" template="CrmSalesLineDataImport.xlsx" class-name="CrmSalesLineDataImport" title="导入" @resdata="getPutIntoZP09Line" />
                <el-button type="primary" style="margin-left: 5px;" @click="handlePutIntoZP09LineTemplateDownload()">下载模版</el-button>
              </div>
              <el-table v-if="!showObj.putIntoZP09" ref="putIntoZP09Table" height="400px" :data="form.putIntoZP09" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip width="200">
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item :prop="'putIntoZP09.' + scope.$index + '.qty' " :rules="putIntoZP09.qty">
                      <el-input v-model="scope.row.qty" min="0" placeholder="请输入" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="单价" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item :prop="'putIntoZP09.' + scope.$index + '.price' " :rules="putIntoZP09.price">
                      <el-input v-model="scope.row.price" min="0" placeholder="请输入" type="number" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="税率(%)" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="taxRatio">
                      <el-input v-model="scope.row.taxRatio" :disabled="true" placeholder="头部的销售组织带出" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次号" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="OE" align="left" show-overflow-tooltip width="150">
                  <template slot-scope="scope">
                    <el-form-item prop="oeCode">
                      <el-input v-model="scope.row.oeCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车辆ID" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carId">
                      <el-input v-model="scope.row.carId" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="carNo">
                      <el-input v-model="scope.row.carNo" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="品牌" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="brand">
                      <el-input v-model="scope.row.brand" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="车系" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="series">
                      <el-input v-model="scope.row.series" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="年款" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="modelYear">
                      <el-input v-model="scope.row.modelYear" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="发动机型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="engineModel">
                      <el-input v-model="scope.row.engineModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="变速箱型号" align="left" show-overflow-tooltip width="120">
                  <template slot-scope="scope">
                    <el-form-item prop="transmissionModel">
                      <el-input v-model="scope.row.transmissionModel" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="排量" align="left" show-overflow-tooltip width="100">
                  <template slot-scope="scope">
                    <el-form-item prop="displacement">
                      <el-input v-model="scope.row.displacement" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="说明" align="left" show-overflow-tooltip width="180">
                  <template slot-scope="scope">
                    <el-form-item prop="note">
                      <el-input v-model="scope.row.note" placeholder="请输入" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handlePutIntoZP09Delete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane> -->
          </el-tabs>
        </el-card>
        <!-- v-if="form.status != 3" -->
        <el-card header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName"
                      :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="6">
                <el-button
                  type="primary"
                  style="margin-bottom: 5px;"
                  @click="addNodePerson()"
                >新增审批人</el-button>
              </el-col>
            </el-row> -->
            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable"
              style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                    <!-- <el-input
                      v-model="scope.row.companyName"
                      disabled
                    /> -->
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="
                      'flowPathNodePersonModels.' + scope.$index + '.nodePerson'
                    " :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search"
                        @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="deleteNodePerson(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId"
            @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary"
            @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary"
            @click="saveAndSubmit()">提交</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="30%"
      :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300"
        @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current"
          :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 售达方 -->
    <el-dialog class="dialog" :title="'选择售达方'" :visible.sync="showObj.soldToParty" width="60%"
      :before-close="soldToPartyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.soldToParty.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getSoldToPartyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" class="selectNone" :data="dialog.soldToParty" border height="300"
        @selection-change="handleSoldToPartySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip />
        <!-- <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip /> -->
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.soldToParty.total" :page.sync="pagination.soldToParty.current"
          :limit.sync="pagination.soldToParty.size" @pagination="getSoldToPartyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="soldToPartyClose">取消</el-button>
        <el-button type="primary" @click="soldToPartyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 送达方 -->
    <el-dialog class="dialog" :title="'选择送达方'" :visible.sync="showObj.deliverySide" width="60%"
      :before-close="deliverySideClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.deliverySide.customerApplyName" clearable placeholder="请输入客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getDeliverySideDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" class="selectNone" :data="dialog.deliverySide" border height="300"
        @selection-change="handleDeliverySideSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="客户编码" align="left" prop="customerApplyNo" show-overflow-tooltip />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip />
        <!-- <el-table-column label="客户类型" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.customerType == 1">固定</span>
            <span v-if="scope.row.customerType == 2">零星</span>
          </template>
        </el-table-column>
        <el-table-column label="经营类别" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.operateCategory | operateCategoryFilters }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" align="left" prop="contacts" show-overflow-tooltip />
        <el-table-column label="联系方式" align="left" prop="contactsPhone" show-overflow-tooltip />
        <el-table-column label="详细地址" align="left" prop="address" show-overflow-tooltip />
        <el-table-column label="单据状态" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">制单</span>
            <span v-if="scope.row.status == 2">审核中</span>
            <span v-if="scope.row.status == 3">审核完成</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
        <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip /> -->
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.deliverySide.total" :page.sync="pagination.deliverySide.current"
          :limit.sync="pagination.deliverySide.size" @pagination="getDeliverySideDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliverySideClose">取消</el-button>
        <el-button type="primary" @click="deliverySideConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 中间公司 -->
    <el-dialog class="dialog" :title="'选择中间公司'" :visible.sync="showObj.middleCompany" width="60%"
      :before-close="middleCompanyClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.middleCompany.customerApplyName" clearable placeholder="请输入销售客户名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getMiddleCompanyDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.middleCompany" border height="300"
        @selection-change="handleMiddleCompanySelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="销售组织编码" align="left" prop="salesOrganizationCode" show-overflow-tooltip width="120" />
        <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
        <el-table-column label="销售客户" align="left" prop="customerApplyName" show-overflow-tooltip width="150" />
        <el-table-column label="采购组织编码" align="left" prop="purchasingOrganizationCode" show-overflow-tooltip
          width="120" />
        <el-table-column label="采购组织" align="left" prop="purchasingOrganizationName" show-overflow-tooltip
          width="150" />
        <el-table-column label="采购供应商" align="left" prop="supplierName" show-overflow-tooltip width="150" />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.middleCompany.total" :page.sync="pagination.middleCompany.current"
          :limit.sync="pagination.middleCompany.size" @pagination="getMiddleCompanyDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="middleCompanyClose">取消</el-button>
        <el-button type="primary" @click="middleCompanyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品配料 -->
    <el-dialog class="dialog" title="产品配料" :visible.sync="showObj.mountings" width="70%" :before-close="mountingsClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="5">
          <el-input v-model="condition.mountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.preciseQuery" clearable placeholder="精准编码查询" />
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.productCodes" readonly placeholder="点击图标批量编码查询">
            <el-button slot="append" icon="el-icon-search" @click="selectMountingsCodes" />
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="5">
          <el-input v-model="condition.mountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="4">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.mountings" :data="dialog.mountings" border height="300"
        @selection-change="handleMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" width="150" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" width="150" show-overflow-tooltip />
        <el-table-column label="批次号" align="left" prop="batch" width="150" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" prop="carId" width="150" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" width="150" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <el-table-column label="发动机型号" align="left" width="150" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" width="150" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" width="150" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.mountings.total" :page.sync="pagination.mountings.current"
          :limit.sync="pagination.mountings.size" @pagination="getMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsClose">取消</el-button>
        <el-button type="primary" @click="mountingsConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品废料 -->
    <el-dialog class="dialog" title="产品废料" :visible.sync="showObj.flotsam" width="70%" :before-close="flotsamClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productCodes" readonly placeholder="点击图标批量编码查询">
            <el-button slot="append" icon="el-icon-search" @click="selectFlotsamCodes" />
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.flotsam" :data="dialog.flotsam" border height="300"
        @selection-change="handleFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.flotsam.total" :page.sync="pagination.flotsam.current"
          :limit.sync="pagination.flotsam.size" @pagination="getFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flotsamClose">取消</el-button>
        <el-button type="primary" @click="flotsamConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- zp03散件 -->
    <el-dialog class="dialog" title="散件" :visible.sync="showObj.putIntoZP03" width="70%"
      :before-close="putIntoZP03Close" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.putIntoZP03.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <!-- <el-col :span="6">
          <el-input v-model="condition.putIntoZP03.productCodes" readonly placeholder="点击图标批量编码查询">
            <el-button slot="append" icon="el-icon-search" @click="selectPutIntoZP03Codes" />
          </el-input>
        </el-col> -->
        <el-col :span="6">
          <el-input v-model="condition.putIntoZP03.productCode" clearable placeholder="请输入物料编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getPutIntoZP03('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.putIntoZP03" :data="dialog.putIntoZP03" border height="300"
        @selection-change="handlePutIntoZP03Change">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" width="150" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" width="150" show-overflow-tooltip />
        <el-table-column label="批次号" align="left" prop="batch" width="150" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" prop="carId" width="150" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" width="150" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <el-table-column label="发动机型号" align="left" width="150" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" width="150" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="重量" align="left" width="150" prop="weight" show-overflow-tooltip />
        <el-table-column label="排量" align="left" width="150" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.putIntoZP03.total" :page.sync="pagination.putIntoZP03.current"
          :limit.sync="pagination.putIntoZP03.size" @pagination="getPutIntoZP03" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="putIntoZP03Close">取消</el-button>
        <el-button type="primary" @click="putIntoZP03Confirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- zp09散件 -->
    <el-dialog class="dialog" title="散件" :visible.sync="showObj.putIntoZP09" width="70%"
      :before-close="putIntoZP09Close" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.putIntoZP09.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.putIntoZP09.productCode" clearable placeholder="请输入物料编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getPutIntoZP09('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.putIntoZP09" :data="dialog.putIntoZP09" border height="300"
        @selection-change="handlePutIntoZP09Change">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" width="150" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" width="150" show-overflow-tooltip />
        <el-table-column label="批次号" align="left" prop="batch" width="150" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" prop="carId" width="150" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" width="150" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <el-table-column label="发动机型号" align="left" width="150" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" width="150" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" width="150" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.putIntoZP09.total" :page.sync="pagination.putIntoZP09.current"
          :limit.sync="pagination.putIntoZP09.size" @pagination="getPutIntoZP09" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="putIntoZP09Close">取消</el-button>
        <el-button type="primary" @click="putIntoZP09Confirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 批量配件编码查询 -->
    <el-dialog class="dialog" :title="'批量编码查询(多个编码请用英文逗号分隔)'" :visible.sync="mountingsCodes" width="50%"
      :before-close="mountingsCodesClose" destroy-on-close center :close-on-click-modal="false">
      <el-input v-model="condition.mountings.productCodes" type="textarea" placeholder="多个编码请用英文逗号分隔" :rows="15" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsCodesClose">取消</el-button>
        <el-button type="primary" @click="mountingsCodesClose">确认</el-button>
      </span>
    </el-dialog>
    <!-- 批量废料编码查询 -->
    <el-dialog class="dialog" :title="'批量编码查询(多个编码请用英文逗号分隔)'" :visible.sync="flotsamCodes" width="50%"
      :before-close="flotsamCodesClose" destroy-on-close center :close-on-click-modal="false">
      <el-input v-model="condition.flotsam.productCodes" type="textarea" placeholder="多个编码请用英文逗号分隔" :rows="15" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="flotsamCodesClose">取消</el-button>
        <el-button type="primary" @click="flotsamCodesClose">确认</el-button>
      </span>
    </el-dialog>
    <!-- 选择来源订单 -->
    <el-dialog class="dialog" title="选择来源订单" :visible.sync="showObj.sourceOrder" width="70%"
      :before-close="sourceOrderClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-select v-model="condition.sourceOrder.sourceOrderType" placeholder="请选择来源订单类型">
            <el-option v-for="item in sourceOrderTypeOptions" :key="item.code" :label="item.name" :value="item.code" />
          </el-select>
        </el-col>
        <el-col v-if="condition.sourceOrder.sourceOrderType === '2'" :span="6">
          <el-input v-model.trim="condition.sourceOrder.plateNumber" clearable placeholder="请输入车牌号" />
        </el-col>

        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getSourceOrderDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.sourceOrder" :data="dialog.sourceOrder" border height="300"
        @selection-change="handleSourceOrderSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="订单编号" align="left" prop="sourceOrderSn" show-overflow-tooltip />
        <el-table-column v-if="condition.sourceOrder.sourceOrderType === '2'" label="车牌" align="left" prop="plateNumber"
          show-overflow-tooltip />
        <el-table-column label="订单名称" align="left" prop="sourceOrderName" show-overflow-tooltip />
        <el-table-column label="订单类型" align="left" prop="sourceOrderType" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.sourceOrderType | sourceOrderFilters }}
          </template>
        </el-table-column>
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.sourceOrder.total" :page.sync="pagination.sourceOrder.current"
          :limit.sync="pagination.sourceOrder.size" @pagination="getSourceOrderDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sourceOrderClose">取消</el-button>
        <el-button type="primary" @click="sourceOrderConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!--来源订单-配件 -->
    <el-dialog class="dialog" title="来源订单配件明细" :visible.sync="showObj.sourceMountings" width="70%"
      :before-close="sourceMountingsClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="4">
          <el-input v-model="condition.sourceMountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="condition.sourceMountings.preciseQuery" clearable placeholder="精准编码查询" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="condition.sourceMountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="condition.sourceMountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="condition.sourceMountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="4">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getSourceMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.sourceMountings" :data="dialog.sourceMountings" border
        height="300" @selection-change="handleSourceMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" width="150" show-overflow-tooltip />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip />
        <el-table-column label="OE" align="left" prop="oeCode" width="150" show-overflow-tooltip />
        <el-table-column label="批次号" align="left" prop="batch" width="150" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" prop="carId" width="150" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" prop="carNo" width="150" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <el-table-column label="发动机型号" align="left" width="150" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" width="150" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" width="150" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.sourceMountings.total" :page.sync="pagination.sourceMountings.current"
          :limit.sync="pagination.sourceMountings.size" @pagination="getSourceMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sourceMountingsClose">取消</el-button>
        <el-button type="primary" @click="sourceMountingsConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 来源订单-废料 -->
    <el-dialog class="dialog" title="来源订单废料明细" :visible.sync="showObj.sourceFlotsam" width="70%"
      :before-close="sourceFlotsamClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.sourceFlotsam.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.sourceFlotsam.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getSourceFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.sourceFlotsam" :data="dialog.sourceFlotsam" border height="300"
        @selection-change="handleSourceFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="客户名称" align="left" prop="customerApplyName" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.sourceFlotsam.total" :page.sync="pagination.sourceFlotsam.current"
          :limit.sync="pagination.sourceFlotsam.size" @pagination="getSourceFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sourceFlotsamClose">取消</el-button>
        <el-button type="primary" @click="sourceFlotsamConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 配件-采购订单 -->
    <el-dialog class="dialog" title="采购订单信息" :visible.sync="showObj.purchase" width="50%" :before-close="purchaseClose"
      destroy-on-close center>
      <el-form ref="purchaseForm" :model="purchaseRow" :disabled="type == '查看'|| isRejectTo" :rules="purchaseRules"
        label-width="120px">
        <el-form-item label="采购订单号" prop="poNo">
          <el-input v-model="purchaseRow.poNo" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="sap采购订单号" prop="sapPoNo">
          <el-input v-model="purchaseRow.sapPoNo" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <el-select v-model="purchaseRow.supplierId">
            <el-option v-for="item in supplierOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="采购组织" prop="purchasingOrganizationId">
          <el-select v-model="purchaseRow.purchasingOrganizationId">
            <el-option v-for="item in purchasingOrganizationOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="采购组" prop="purchaseBasicsId">
          <el-select v-model="purchaseRow.purchaseBasicsId">
            <el-option v-for="item in purchaseBasicsOptions" :key="item.value" :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="公司代码" prop="companyInfoNumber">
          <el-input v-model="purchaseRow.companyInfoNumber" readonly placeholder="请点击图标选择">
            <el-button slot="append" icon="el-icon-search" @click="setCompany" />
          </el-input>
        </el-form-item> -->
        <el-form-item label="单价" prop="unitPrice">
          <el-input v-model.number="purchaseRow.unitPrice" type="number" placeholder="请输入单价" clearable />
        </el-form-item>
        <el-form-item label="数量" prop="qty">
          <el-input v-model.number="purchaseRow.qty" type="number" placeholder="请输入数量" clearable />
        </el-form-item>
        <el-form-item label="进项税" prop="taxCode">
          <el-select v-model="purchaseRow.taxCode">
            <el-option v-for="item in inputTaxOptions" :key="item.code" :label="item.name +'-'+item.code"
              :value="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="purchaseConfirm">确认</el-button>
          <el-button @click="purchaseClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 基础数据-选择公司 -->
    <el-dialog class="dialog" title="选择公司" :visible.sync="showObj.company" width="70%" :before-close="companyClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-table ref="listTable" v-loading="loadingObj.company" :data="dialog.company" border height="300"
        @selection-change="handleCompanyChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="公司代码" align="left" prop="companyInfoNumber" show-overflow-tooltip />
        <el-table-column label="公司描述" align="left" prop="companyInfoName" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.company.total" :page.sync="pagination.company.current"
          :limit.sync="pagination.company.size" @pagination="getCompany" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="companyClose">取消</el-button>
        <el-button type="primary" @click="companyConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 配件-选择通用物料 commons -->
    <el-dialog class="dialog" title="选择通用物料" :visible.sync="showObj.commons" width="70%" :before-close="commonsClose"
      destroy-on-close center :close-on-click-modal="false">
      <el-table ref="listTable" v-loading="loadingObj.commons" :data="dialog.commons" border height="300"
        @selection-change="handleCommonsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="产品名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="单位名称" align="left" prop="unit" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.commons.total" :page.sync="pagination.commons.current"
          :limit.sync="pagination.commons.size" @pagination="getCommons" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="commonsClose">取消</el-button>
        <el-button type="primary" @click="commonsConfirm">确认</el-button>
      </span>
    </el-dialog>

    <!-- 选择跟单员 -->
    <el-dialog class="dialog" title="选择跟单员" :visible.sync="showObj.orderFollower" width="70%"
      :before-close="orderFollowerClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search"
            @click="getOrderFollowerDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.orderFollower" :data="dialog.orderFollower" border height="300"
        @selection-change="handleOrderFollowerSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="订单名称" align="left" prop="name" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.orderFollower.total" :page.sync="pagination.orderFollower.current"
          :limit.sync="pagination.orderFollower.size" @pagination="getOrderFollowerDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderFollowerClose">取消</el-button>
        <el-button type="primary" @click="orderFollowerConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import FileUpload from '@/components/FileUpload/index'
import UploadPicture from '@/views/crm/order/salesOrder/uploadPicture.vue'
import ExcelImport from '@/components/ExcelImport'
import { getPage as getSalesOrganization } from '@/api/crm/base/salesOrganization'
import { getPage as getDistributionChannels } from '@/api/crm/base/distributionChannels'
import { get as getProductTeam } from '@/api/crm/base/distributionChannels'
import { getPage as getFactory } from '@/api/crm/base/factory'
import { getPage as getTaxRate } from '@/api/crm/base/taxRate'
import { getPage as getSupplierOptions } from '@/api/crm/base/supplier'
import { getPage as getPurchaseBasicsOptions } from '@/api/crm/base/purchase'
import { getPage as getPurchasingOrganization } from '@/api/crm/base/purchasingOrganization'

import { getPagePopup as getMountingsApi } from '@/api/crm/product/fittings'
import { getPagePopup as getFlotsamApi } from '@/api/crm/product/scraps'
import { getPage as getCommonssApi } from '@/api/crm/product/commons'

import { downloadFile } from '@/utils/file'
import { getBusinessType } from '@/api/crm/base/businessTypeDict'
import Pagination from '@/components/Pagination'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'
import { getEnumItems } from '@/utils/enum'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'
import {
  get,
  saveOrUpdate,
  getByCustomerApply,
  getByMiddleCompany,
  submit,
  downloadMountingsLineTemplate,
  downloadPutIntoZP03LineTemplate,
  getSourceApi,
  getFollowerApi,
  searchSourceOrders,
  searchSourceOrdersFlotsam,
  getCommonList,
} from '@/api/crm/order/salesOrder'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
import { getByGeneralManager } from '@/api/crm/base/audit'
import { getPage as getCompany } from '@/api/crm/base/company'
export default {
  name: 'SalesOrderEdit',
  components: {
    Pagination,
    FileUpload,
    Flow,
    ExcelImport,
    UploadPicture
  },
  filters: {
    operateCategoryFilters(e) {
      const arr = e.split(',')
      const arr1 = getEnumItems('Crm_Business_Category')
      const arr2 = []
      for (const item of arr) {
        for (const v of arr1) {
          if (v.code === item) {
            arr2.push(v.name)
          }
        }
      }
      console.log(arr2.join())
      return arr2.join()
    },
    sourceOrderFilters(e) {
      return ['', '投标订单', '预销售订单', '委外加工单'][e]
    }
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      companyOptions: [],
      salesOrganizationOptions: [],
      channelDistributioOption: [],
      productTeamOption: [],
      businessTypeOptions: [],
      factoryOptions: [],
      flowPathOptions: [],
      isPartsOptions: [{ value: 0, label: '否' }, { value: 1, label: '是' }],
      whetherToReturnOptions: [{ value: 0, label: '否' }, { value: 1, label: '是' }],
      lowPriceReasons: [{ value: 1, label: '质量问题扣杂' }, { value: 2, label: '公式价偏高' }],
      format: format,
      areaData: [],
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        orderTime: format.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        flotsamList: [],
        mountingsList: [],
        isVatRetreat: 0,
        salesOrganizationId: null,
        channelOfDistributionId: null,
        productTeamId: null,
        salesCode: null,
        soldToPartyName: null,
        flowPathNodePersonModels: [],
        flowPathTemplateId: null,
        roleId: null,
        orderFollower: null,
        crmSalesOrdersLooseItemsModels: [],
        crmSalesOrdersAccessoryModels: [],
        putIntoZP03: [],
        putIntoZP09: []
      },
      statusArr: ['', '制单', '审核中', '审核完成'],
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      putIntoZP03: {
        qty: [
          { required: true, message: '散件数量不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '散件单价不能为空', trigger: 'blur' }
        ]
      },
      putIntoZP09: {
        qty: [
          { required: true, message: '散件数量不能为空', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '散件单价不能为空', trigger: 'blur' }
        ]
      },
      mountingsList: {
        qty: [
          { required: true, message: '配件订单数量不能为空', trigger: 'blur' }
        ],
        taxPrice: [
          { required: true, message: '配件含税单价不能为空', trigger: 'blur' }
        ]
      },
      flotsamList: {
        qty: [
          { required: true, message: '废料订单数量不能为空', trigger: 'blur' }
        ],
        taxPrice: [
          { required: true, message: '废料含税单价不能为空', trigger: 'blur' }
        ]
      },
      rules: {
        salesCode: [
          { required: true, message: '单据类型不能为空', trigger: 'change' }
        ],
        businessTypeId: [
          { required: false, message: '业务类型不能为空', trigger: 'change' }
        ],

        salesOrganizationId: [
          { required: true, message: '销售组织不能为空', trigger: 'change' }
        ],
        channelOfDistributionId: [
          { required: true, message: '分销渠道不能为空', trigger: 'change' }
        ],
        productTeamId: [
          { required: true, message: '产品组不能为空', trigger: 'change' }
        ],
        soldToPartyName: [
          { required: true, message: '售达方不能为空', trigger: 'change' }
        ],
        // factoryId: [
        //   { required: true, message: '交货工厂不能为空', trigger: 'change' }
        // ],
        orderTime: [
          { required: true, message: '单据日期不能为空', trigger: 'change' }
        ],
        orderFollower: [
          { required: true, message: '跟单员不能为空', trigger: 'change' }
        ]
      },
      purchaseRules: {
        purchasingOrganizationId: [
          { required: true, message: '采购组织不能为空', trigger: 'change' }
        ],
        unitPrice: [
          { required: true, message: '单价不能为空', trigger: 'blur' }
        ],
        qty: [
          { required: true, message: '数量不能为空', trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: '进项税不能为空', trigger: 'change' }
        ]
      },
      clientClassOptions: [],
      separateTypeOption: getEnumItems('Separate_Type_Code'),
      salesTypeOptions: getEnumItems('hlCrmSalesType'),
      activePaneName: 'mountings',
      showObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        flotsam: false,
        nodePerson: false,
        putIntoZP03: false,
        putIntoZP09: false,
        sourceOrder: false,
        orderFollower: false,
        sourceMountings: false,
        sourceFlotsam: false,
        purchase: false,
        company: false,
        commons: false
      },
      loadingObj: {
        mountings: false,
        soldToParty: false,
        deliverySide: false,
        middleCompany: false,
        flotsam: false,
        nodePerson: false,
        putIntoZP03: false,
        putIntoZP09: false,
        sourceOrder: false,
        orderFollower: false,
        sourceMountings: false,
        sourceFlotsam: false,
        company: false,
        commons: false
      },
      // 分页
      pagination: {
        mountings: {
          total: 0,
          size: 20,
          current: 1
        },
        soldToParty: {
          total: 0,
          size: 20,
          current: 1
        },
        deliverySide: {
          total: 0,
          size: 20,
          current: 1
        },
        middleCompany: {
          total: 0,
          size: 20,
          current: 1
        },
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        },
        flotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        putIntoZP03: {
          total: 0,
          size: 20,
          current: 1
        },
        putIntoZP09: {
          total: 0,
          size: 20,
          current: 1
        },
        sourceOrder: {
          total: 0,
          size: 20,
          current: 1
        },
        orderFollower: {
          total: 0,
          size: 20,
          current: 1
        },
        sourceMountings: {
          total: 0,
          size: 20,
          current: 1
        },
        sourceFlotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        company: {
          total: 0,
          size: 20,
          current: 1
        },
        commons: {
          total: 0,
          size: 20,
          current: 1
        }

      },
      dialog: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        flotsam: [],
        nodePerson: [],
        putIntoZP03: [],
        putIntoZP09: [],
        sourceOrder: [],
        sourceMountings: [],
        sourceFlotsam: [],
        company: [],
        commons: []
      },
      condition: {
        mountings: {},
        soldToParty: {},
        deliverySide: {},
        middleCompany: {},
        flotsam: {},
        nodePerson: {},
        putIntoZP03: {},
        putIntoZP09: {},
        sourceOrder: {},
        orderFollower: {},
        sourceMountings: {},
        sourceFlotsam: {},
        company: {},
        commons: {}
      },
      selection: {
        mountings: [],
        soldToParty: [],
        deliverySide: [],
        middleCompany: [],
        flotsam: [],
        nodePerson: [],
        putIntoZP03: [],
        putIntoZP09: [],
        sourceOrder: [],
        orderFollower: [],
        sourceMountings: [],
        sourceFlotsam: [],
        company: [],
        commons: []
      },
      nodePersonIndex: null,
      isDisabled: false,
      isRejectTo: false,
      mountingsCodes: false,
      flotsamCodes: false,
      sourceOrderTypeOptions: getEnumItems('Crm_Source_Order'),
      purchaseRow: {
        poNo: null,
        sapPoNo: null,
        supplierId: null,
        purchasingOrganizationId: null,
        purchaseBasicsId: null,
        unitPrice: null,
        qty: null,
        taxCode: null

      },
      purchaseIndex: null,
      supplierOptions: [],
      purchaseBasicsOptions: [],
      inputTaxOptions: getEnumItems('InputTax'),
      purchasingOrganizationOptions: []
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }
      this.init()
      this.flowPathNodePersonModels.nodePerson[0].required = false
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    },
    'form.mountingsList': {
      handler(val) {
        this.judegIsDisabled()
      }
    },
    'form.flotsamList': {
      handler(val) {
        this.judegIsDisabled()
      }
    },
    'form.putIntoZP03': {
      handler(val) {
        this.judegIsDisabled()
      }
    },
    'form.putIntoZP09': {
      handler(val) {
        this.judegIsDisabled()
      }
    }
  },
  methods: {
    init() {
      getSalesOrganization({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data

        this.salesOrganizationOptions = records.map((item) => {
          return {
            label: item.salesOrganizationName,
            value: item.id
          }
        })
        this.newAcquiesce(records[0].id)
      })
      getFactory({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.factoryOptions = records.map((item) => {
          return {
            label: item.factoryNumber + '-' + item.factoryName,
            value: item.id
          }
        })
        this.form.factoryId = this.factoryOptions[0].value
      })
      getPurchasingOrganization({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.purchasingOrganizationOptions = records.map((item) => {
          return {
            label: item.purchasingOrganizationNumber + '-' + item.purchasingOrganizationName,
            value: item.id
          }
        })
      })
      getSupplierOptions({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.supplierOptions = records.map((item) => {
          return {
            label: item.supplierNo + '-' + item.supplierName,
            value: item.id
          }
        })
      })
      getPurchaseBasicsOptions({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.purchaseBasicsOptions = records.map((item) => {
          return {
            label: item.purchaseNo + '-' + item.purchaseName,
            value: item.id
          }
        })
      })
      getByPathTemplate({ templateType: '订单' }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
        console.log(this.flowPathOptions)
      })
    },
    async newAcquiesce(salesOrganizationId) {
      // 默认值
      if (this.editId == null) {
        this.form.salesOrganizationId = salesOrganizationId

        const channelOfDistribution = await this.getChannelDistributioOption(salesOrganizationId)

        this.getOptionOrganizationTaxRate(salesOrganizationId)
        this.getBusinessTypeOption(salesOrganizationId)
        // 单据类型
        const salesType = getEnumItems('hlCrmSalesType')
        const companyInfoNumber = this.$store.getters.companyInfo.companyInfoNumber
        if (companyInfoNumber === '1010' || companyInfoNumber === '1020') {
          this.form.salesCode = salesType[0].code
          this.form.salesName = salesType[0].name
          const i = channelOfDistribution.findIndex(item => item.label === '废料')
          this.form.channelOfDistributionId = channelOfDistribution[i]?.value || ''
          const productTeamOption = await this.getProductTeamOption(this.form.channelOfDistributionId)
          this.form.productTeamId = productTeamOption[0].value
          this.activePaneName = 'flotsam'
        }
        if (companyInfoNumber === '1050') {
          this.form.salesCode = salesType[1].code
          this.form.salesName = salesType[1].name
          const i = channelOfDistribution.findIndex(item => item.label === '配件')
          this.form.channelOfDistributionId = channelOfDistribution[i]?.value || ''
          const productTeamOption = await this.getProductTeamOption(this.form.channelOfDistributionId)
          this.form.productTeamId = productTeamOption[0].value
          this.rules.businessTypeId[0].required = true
          this.activePaneName = 'mountings'
        } else {
          this.rules.businessTypeId[0].required = false
        }
      }
    },
    // 审批人
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId
      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    // addNodePerson() {
    //   if (this.form.flowPathNodePersonModels === null) {
    //     this.form.flowPathNodePersonModels = []
    //   }
    //   this.form.flowPathNodePersonModels.push({})
    // },
    // deleteNodePerson(index) {
    //   this.form.flowPathNodePersonModels.splice(index, 1)
    // },
    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },

    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },
    // 基础数据
    changeSalesType(e) {
      this.activePaneName = e === 'ZOR1' ? 'flotsam' : 'mountings'
      const i = this.salesTypeOptions.findIndex((item) => item.code === e)
      if (i >= 0) {
        this.form.salesName = this.salesTypeOptions[i].name
      }
    },
    getOptionOrganization(id) {
      this.getChannelDistributioOption(id)
      this.getOptionOrganizationTaxRate(id)
      this.getBusinessTypeOption(id)
    },
    getBusinessTypeOption(id) {
      getBusinessType({ salesOrganizationId: id }, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.businessTypeOptions = records.map((item) => {
          return {
            label: item.salesOfficeCode + '-' + item.salesOfficeName,
            value: item.id
          }
        })
      })
    },
    async getOptionOrganizationTaxRate(id) {
      const { data } = await getTaxRate({ salesOrganizationId: id }, {
        total: 0,
        size: 20,
        current: 1
      })
      this.taxRatio = data.records[0].taxRatio
      // this.calculation()
    },

    // 获取分销渠道
    async getChannelDistributioOption(id) {
      const { data } = await getDistributionChannels({ id }, { current: 1, size: 1000 })
      this.channelDistributioOption = data.records.map((item) => {
        return {
          label: item.channelDistributioName,
          value: item.id + ''
        }
      })
      return this.channelDistributioOption
    },
    // 获取产品组
    async getProductTeamOption(id) {
      const { data } = await getProductTeam(id)
      this.productTeamOption = data.productTeamList.map((item) => {
        return {
          label: item.productTeamName,
          value: item.id + ''
        }
      })
      this.form.productTeamId = ''
      return this.productTeamOption
    },
    // 售达方
    selectSoldToParty() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.soldToParty = true
      this.getSoldToPartyDialog()
    },
    async getSoldToPartyDialog() {
      this.loadingObj.soldToParty = true
      const data = {
        condition: {
          salesOrganizationId: this.form.salesOrganizationId,
          status: 3,
          customerApplyName: this.condition.soldToParty.customerApplyName,
          notBlacklist: 2
        },
        pagination: this.pagination.soldToParty
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.soldToParty = records
      this.pagination.soldToParty.total = total
      this.pagination.soldToParty.current = current
      this.pagination.soldToParty.size = size
      this.loadingObj.soldToParty = false
    },

    handleSoldToPartySelectionChange(val) {
      this.selection.soldToParty = val
    },
    soldToPartyConfirm() {
      if (this.selection.soldToParty.length > 1) {
        this.$message.warning('只能选择一位售达方！')
      } else {
        this.showObj.soldToParty = false
        console.log(this.selection.soldToParty)
        this.form.soldToPartyId = this.selection.soldToParty[0].id
        this.form.soldToPartyName = this.selection.soldToParty[0].customerApplyName
      }
    },
    soldToPartyClose() {
      this.showObj.soldToParty = false
    },
    // 送达方
    selectDeliverySide() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.deliverySide = true
      this.getDeliverySideDialog()
    },
    async getDeliverySideDialog() {
      this.loadingObj.deliverySide = true
      const data = {
        condition: {
          salesOrganizationId: this.form.salesOrganizationId,
          status: 3,
          customerApplyName: this.condition.deliverySide.customerApplyName,
          notBlacklist: 2
        },
        pagination: this.pagination.deliverySide
      }
      const reponse = await getByCustomerApply(data)
      const { current, total, size, records } = reponse.data
      this.dialog.deliverySide = records
      this.pagination.deliverySide.total = total
      this.pagination.deliverySide.current = current
      this.pagination.deliverySide.size = size
      this.loadingObj.deliverySide = false
    },
    handleDeliverySideSelectionChange(val) {
      this.selection.deliverySide = val
    },
    deliverySideConfirm() {
      if (this.selection.deliverySide.length > 1) {
        this.$message.warning('只能选择一位送达方！')
      } else {
        this.showObj.deliverySide = false
        console.log(this.selection.deliverySide)
        this.form.deliverySideId = this.selection.deliverySide[0].id
        this.form.deliverySideName = this.selection.deliverySide[0].customerApplyName
      }
    },
    deliverySideClose() {
      this.showObj.deliverySide = false
    },
    // 中间公司
    selectMiddleCompany() {
      if (!this.form.salesOrganizationId) {
        this.$message({
          type: 'warning',
          message: '请先选择销售组织'
        })
        return
      }
      this.showObj.middleCompany = true
      this.getMiddleCompanyDialog()
    },
    async getMiddleCompanyDialog() {
      this.loadingObj.middleCompany = true
      const data = {
        customerApplyName: this.condition.middleCompany.customerApplyName,
        salesOrganizationId: this.form.salesOrganizationId,
        pagination: this.pagination.middleCompany
      }
      const reponse = await getByMiddleCompany(data)
      const { current, total, size, records } = reponse.data
      this.dialog.middleCompany = records
      this.pagination.middleCompany.total = total
      this.pagination.middleCompany.current = current
      this.pagination.middleCompany.size = size
      this.loadingObj.middleCompany = false
    },
    handleMiddleCompanySelectionChange(val) {
      this.selection.middleCompany = val
    },
    middleCompanyConfirm() {
      if (this.selection.middleCompany.length > 1) {
        this.$message.warning('只能选择一个中间公司！')
      } else {
        this.showObj.middleCompany = false
        console.log(this.selection.middleCompany)
        this.form.middleCompanyId = this.selection.middleCompany[0].id
        this.form.middleCompanyName = this.selection.middleCompany[0].customerApplyName
      }
    },
    middleCompanyClose() {
      this.showObj.middleCompany = false
    },
    // 配件
    addMountingsLine() {
      if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
        this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
        return
      }
      this.showObj.mountings = true
      this.getMountings()
    },
    delectMountingsLine() {
      this.form.mountingsList = []
    },
    async getMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      const reponse = await getMountingsApi(this.condition.mountings, this.pagination.mountings)
      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    handleMountingsDelete(index) {
      this.form.mountingsList.splice(index, 1)
    },
    handleMountingsChange(val) {
      this.selection.mountings = val
    },
    mountingsConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      if (arr !== null && arr.length > 0) {
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
      } else {
        this.form.mountingsList = this.selection.mountings
      }
      for (const item of this.form.mountingsList) {
        item.productType = 1
        item.isParts = 0
      }
      if (!isNaN(this.taxRatio)) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
        })
      }
      this.showObj.mountings = false
    },

    mountingsClose() {
      this.showObj.mountings = false
    },
    // 配件批量编码查询
    selectMountingsCodes() {
      this.mountingsCodes = true
    },
    mountingsCodesClose() {
      this.mountingsCodes = false
    },
    // 废料批量编码查询
    selectFlotsamCodes() {
      this.flotsamCodes = true
    },
    flotsamCodesClose() {
      this.flotsamCodes = false
    },
    // 配件选择拆解类型
    setSeparateType(e, i) {
      console.log(e, i)
    },
    // 废料
    addFlotsamLine() {
      if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
        this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
        return
      }
      this.showObj.flotsam = true
      this.getFlotsam()
    },
    delectFlotsamLine() {
      this.form.flotsamList = []
    },
    async getFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.flotsam.current = 1
      }
      this.loadingObj.flotsam = true
      const reponse = await getFlotsamApi(this.condition.flotsam, this.pagination.flotsam)
      const { current, total, size, records } = reponse.data
      this.dialog.flotsam = records
      this.pagination.flotsam.total = total
      this.pagination.flotsam.current = current
      this.pagination.flotsam.size = size
      this.loadingObj.flotsam = false
    },
    handleFlotsamDelete(index) {
      this.form.flotsamList.splice(index, 1)
    },
    handleFlotsamChange(val) {
      this.selection.flotsam = val
    },
    flotsamConfirm() {
      const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
      if (arr !== null && arr.length > 0) {
        this.form.flotsamList = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode')
      } else {
        this.form.flotsamList = this.selection.flotsam
      }
      for (const item of this.form.flotsamList) {
        item.productType = 2
      }
      this.form.flotsamList.forEach((item, index) => {
        this.$set(this.form.flotsamList[index], 'isParts', 0)
        this.$set(this.form.flotsamList[index], 'whetherToReturn', 0)
        //扣杂数量默认为0
        this.$set(this.form.flotsamList[index], 'deductionAmount', 0)
      })
      if (!isNaN(this.taxRatio)) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
        })
      }
      console.log(this.form.flotsamList)
      this.showObj.flotsam = false
    },
    flotsamClose() {
      this.showObj.flotsam = false
    },
    // zp03散件
    addPutIntoZP03Line() {
      if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
        this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
        return
      }
      this.showObj.putIntoZP03 = true
      this.getPutIntoZP03()
    },
    delectPutIntoZP03Line() {
      this.form.putIntoZP03 = []
    },
    async getPutIntoZP03(type = '') {
      if (type === 'refresh') {
        this.pagination.putIntoZP03.current = 1
      }
      this.loadingObj.putIntoZP03 = true
      const reponse = await getMountingsApi(this.condition.putIntoZP03, this.pagination.putIntoZP03)
      const { current, total, size, records } = reponse.data
      this.dialog.putIntoZP03 = records
      this.pagination.putIntoZP03.total = total
      this.pagination.putIntoZP03.current = current
      this.pagination.putIntoZP03.size = size
      this.loadingObj.putIntoZP03 = false
    },
    handlePutIntoZP03Delete(index) {
      this.form.putIntoZP03.splice(index, 1)
    },
    handlePutIntoZP03Change(val) {
      this.selection.putIntoZP03 = val
    },
    putIntoZP03Confirm() {
      const arr = JSON.parse(JSON.stringify(this.form.putIntoZP03))
      if (arr !== null && arr.length > 0) {
        this.form.putIntoZP03 = mergeObjectArrayWithoutDuplicates(arr, this.selection.putIntoZP03, 'productCode', 'batch')
      } else {
        this.form.putIntoZP03 = this.selection.putIntoZP03
      }
      if (!isNaN(this.taxRatio)) {
        this.form.putIntoZP03.forEach((item, index) => {
          this.$set(this.form.putIntoZP03[index], 'taxRatio', this.taxRatio)
        })
      }
      for (const item of this.form.putIntoZP03) {
        item.partType = 1
      }
      this.showObj.putIntoZP03 = false
    },
    putIntoZP03Close() {
      this.showObj.putIntoZP03 = false
    },
    // zp09散件
    addPutIntoZP09Line() {
      if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
        this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
        return
      }
      this.showObj.putIntoZP09 = true
      this.getPutIntoZP09()
    },
    delectPutIntoZP09Line() {
      this.form.putIntoZP09 = []
    },
    async getPutIntoZP09(type = '') {
      if (type === 'refresh') {
        this.pagination.putIntoZP09.current = 1
      }
      this.loadingObj.putIntoZP09 = true
      const reponse = await getMountingsApi(this.condition.putIntoZP09, this.pagination.putIntoZP09)
      const { current, total, size, records } = reponse.data
      this.dialog.putIntoZP09 = records
      this.pagination.putIntoZP09.total = total
      this.pagination.putIntoZP09.current = current
      this.pagination.putIntoZP09.size = size
      this.loadingObj.putIntoZP09 = false
    },
    handlePutIntoZP09Delete(index) {
      this.form.putIntoZP09.splice(index, 1)
    },
    handlePutIntoZP09Change(val) {
      this.selection.putIntoZP09 = val
    },
    putIntoZP09Confirm() {
      const arr = JSON.parse(JSON.stringify(this.form.putIntoZP09))
      if (arr !== null && arr.length > 0) {
        this.form.putIntoZP09 = mergeObjectArrayWithoutDuplicates(arr, this.selection.putIntoZP09, 'productCode', 'batch')
      } else {
        this.form.putIntoZP09 = this.selection.putIntoZP09
      }
      if (!isNaN(this.taxRatio)) {
        this.form.putIntoZP09.forEach((item, index) => {
          this.$set(this.form.putIntoZP09[index], 'taxRatio', this.taxRatio)
        })
      }
      for (const item of this.form.putIntoZP09) {
        item.partType = 2
      }
      this.showObj.putIntoZP09 = false
    },
    putIntoZP09Close() {
      this.showObj.putIntoZP09 = false
    },
    //  选择来源订单
    selectSourceOrder() {
      this.showObj.sourceOrder = true
      if (this.condition.sourceOrder?.sourceOrderType) {
        this.getSourceOrderDialog()
      }
    },
    async getSourceOrderDialog(type = '') {
      if (type === 'refresh') {
        this.pagination.sourceOrder.current = 1
      }
      if (!this.condition.sourceOrder.sourceOrderType) {
        this.$message.warning('请先选择来源订单类型')
        return
      }
      this.loadingObj.sourceOrder = true
      this.condition.sourceOrder
      const { data } = await getSourceApi({ condition: this.condition.sourceOrder, pagination: this.pagination.sourceOrder })

      this.dialog.sourceOrder = data?.records || []
      this.pagination.sourceOrder.total = data?.total || 0
      this.pagination.sourceOrder.current = data?.current || 1
      this.pagination.sourceOrder.size = data?.size || 20
      this.loadingObj.sourceOrder = false
    },
    handleSourceOrderSelectionChange(val) {
      this.selection.sourceOrder = val
    },
    sourceOrderConfirm() {
      if (this.selection.sourceOrder.length > 1) {
        this.$message.warning('只能选择一个来源订单！')
      } else {
        console.log(this.selection.sourceOrder)
        this.form.sourceOrderSn = this.selection.sourceOrder[0].sourceOrderSn
        this.form.sourceOrderType = this.selection.sourceOrder[0].sourceOrderType
        this.form.sourceOrderId = this.selection.sourceOrder[0].sourceOrderId
        this.form.salesCode = 'ZOR' + this.selection.sourceOrder[0].orderType.toString()
        this.sourceOrderClose()
      }
    },
    sourceOrderClose() {
      this.showObj.sourceOrder = false
    },
    // 来源订单明细-配件
    addSourceMountingsLine() {
      if (!this.form.sourceOrderSn) {
        this.$message.warning('请先选择来源订单')
        return
      }
      this.showObj.sourceMountings = true
      this.getSourceMountings()
    },
    // delectSourceMountingsLine() {
    //   this.form.sourceMountings = []
    // },
    async getSourceMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.sourceMountings.current = 1
      }
      this.loadingObj.sourceMountings = true
      const objData = {
        sourceOrderId: this.form.sourceOrderId,
        sourceOrderType: this.form.sourceOrderType,
        condition: this.condition.sourceMountings,
        pagination: this.pagination.sourceMountings
      }
      const reponse = await searchSourceOrders(objData)
      const { current, total, size, records } = reponse.data
      this.dialog.sourceMountings = records
      this.pagination.sourceMountings.total = total
      this.pagination.sourceMountings.current = current
      this.pagination.sourceMountings.size = size
      this.loadingObj.sourceMountings = false
    },
    // handleSourceMountingsDelete(index) {
    //   this.form.sourceMountings.splice(index, 1)
    // },
    handleSourceMountingsChange(val) {
      this.selection.sourceMountings = val
    },
    sourceMountingsConfirm() {
      const arr1 = this.selection.sourceMountings
      for (var i = 0; i < arr1.length; i++) {
        for (var j = i + 1; j < arr1.length; j++) {
          if (arr1[i].customerApplyNo !== arr1[j].customerApplyNo) {
            this.$message.warning('不允许选择不同客户')
            return
          }
        }
      }
      const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      if (arr !== null && arr.length > 0) {
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.sourceMountings, 'productCode', 'batch')
      } else {
        this.form.mountingsList = this.selection.sourceMountings
      }
      for (const item of this.form.mountingsList) {
        item.productType = 1
        item.isParts = 0
      }
      if (!isNaN(this.taxRatio)) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
        })
      }
      this.sourceMountingsClose()
    },
    sourceMountingsClose() {
      this.showObj.sourceMountings = false
    },
    // 来源订单明细-废料
    addSourceFlotsamLine() {
      if (!this.form.sourceOrderSn) {
        this.$message.warning('请先选择来源订单')
        return
      }
      this.showObj.sourceFlotsam = true
      this.getSourceFlotsam()
    },
    async getSourceFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.sourceFlotsam.current = 1
      }
      this.loadingObj.sourceFlotsam = true
      const objData = {
        sourceOrderId: this.form.sourceOrderId,
        sourceOrderType: this.form.sourceOrderType,
        condition: this.condition.sourceFlotsam,
        pagination: this.pagination.sourceFlotsam
      }
      const reponse = await searchSourceOrdersFlotsam(objData)
      const { current, total, size, records } = reponse.data
      this.dialog.sourceFlotsam = records
      this.pagination.sourceFlotsam.total = total
      this.pagination.sourceFlotsam.current = current
      this.pagination.sourceFlotsam.size = size
      this.loadingObj.sourceFlotsam = false
    },
    // handleSourceFlotsamDelete(index) {
    //   this.form.flotsamList.splice(index, 1)
    // },
    handleSourceFlotsamChange(val) {
      this.selection.sourceFlotsam = val
    },
    sourceFlotsamConfirm() {
      const arr1 = this.selection.sourceFlotsam
      for (var i = 0; i < arr1.length; i++) {
        for (var j = i + 1; j < arr1.length; j++) {
          if (arr1[i].customerApplyNo !== arr1[j].customerApplyNo) {
            this.$message.warning('不允许选择不同客户')
            return
          }
        }
      }
      const arr = JSON.parse(JSON.stringify(this.form.flotsamList))
      if (arr !== null && arr.length > 0) {
        this.form.flotsamList = mergeObjectArrayWithoutDuplicates(arr, this.selection.sourceFlotsam, 'productCode')
      } else {
        this.form.flotsamList = this.selection.sourceFlotsam
      }
      for (const item of this.form.flotsamList) {
        item.productType = 2
      }
      this.form.flotsamList.forEach((item, index) => {
        this.$set(this.form.flotsamList[index], 'isParts', 0)
        this.$set(this.form.flotsamList[index], 'whetherToReturn', 0)
      })
      if (!isNaN(this.taxRatio)) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
        })
      }
      console.log(this.form.flotsamList)
      this.sourceFlotsamClose()
    },
    sourceFlotsamClose() {
      this.showObj.sourceFlotsam = false
    },
    // 判断有订单明细就给基础选项上锁
    judegIsDisabled() {
      console.log(this.form.flotsamList)
      if (this.form.flotsamList?.length > 0 || this.form.mountingsList?.length > 0 || this.form.putIntoZP03?.length > 0 || this.form.putIntoZP09?.length > 0) {
        this.isDisabled = true
      }
      if (this.form.flotsamList?.length <= 0 && this.form.mountingsList?.length <= 0 && this.form.putIntoZP03?.length <= 0 && this.form.putIntoZP09?.length <= 0) {
        this.isDisabled = false
      }
    },
    // 计算金额
    calculation() {
      if (this.form.mountingsList.length > 0) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
          // this.$set(this.form.mountingsList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, this.taxRatio))
          this.sumLordDutyPrice(item, index, 'mountings')
        })
      }
      if (this.form.flotsamList.length > 0) {
        this.form.flotsamList.forEach((item, index) => {
          this.$set(this.form.flotsamList[index], 'taxRatio', this.taxRatio)
          // this.$set(this.form.flotsamList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, this.taxRatio))
          this.sumLordDutyPrice(item, index)
        })
      }
    },
    inclusiveAmount(qty, taxPrice) {
      const num = qty * taxPrice
      if (num.toString().split('.')[1] && num.toString().split('.')[1].length > 2) {
        return num.toFixed(2)
      } else {
        return num
      }
    },
    amountExcludingTax(lordDutyPrice, taxRatio) {
      console.log(lordDutyPrice, (1 + taxRatio / 100))
      const num = lordDutyPrice / (1 + taxRatio / 100)
      console.log(num)
      if (num.toString().split('.')[1] && num.toString().split('.')[1].length > 2) {
        return num.toFixed(2)
      } else {
        return num
      }
    },
    restrictNum(item) {
      console.log(item.taxPrice, typeof (item.taxPrice))
      if (item.taxPrice.toString().split('.')[1]) {
        item.taxPrice = item.taxPrice.toString().replace(
          /^(-)*(\d+)\.(\d\d\d\d\d\d).*$/,
          '$1$2.$3'
        )
      }
    },
    sumLordDutyPrice(item, index, type = '') {
      if (!isNaN(item.qty) && !isNaN(item.taxPrice)) {
        if (type === 'mountings') {
          this.$set(this.form.mountingsList[index], 'lordDutyPrice', this.inclusiveAmount(item.qty, item.taxPrice))
          this.sumTaxlessPrice(item, index, 'mountings')
        } else {
          this.$set(this.form.flotsamList[index], 'lordDutyPrice', this.inclusiveAmount(item.qty, item.taxPrice))
          this.sumTaxlessPrice(item, index)
        }
      }
    },
    sumTaxlessPrice(item, index, type = '') {
      console.log(item.lordDutyPrice, item.taxRatio, index)
      if (!isNaN(item.lordDutyPrice) && !isNaN(item.taxRatio)) {
        if (type === 'mountings') {
          this.$set(this.form.mountingsList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, item.taxRatio))
        } else {
          this.$set(this.form.flotsamList[index], 'taxlessPrice', this.amountExcludingTax(item.lordDutyPrice, item.taxRatio))
        }
      }
    },
    // 上传明细表单返回值
    getMountingsLine(e) {
      console.log(e, 111223112)
      if (e.data.length <= 0) {
        this.$message.warning('数据导入失败，请检查数据源')
      } else {
        this.$message.success('数据导入成功')
        this.form.mountingsList = mergeObjectArrayWithoutDuplicates(this.form.mountingsList, e.data, 'productCode', 'batch')
        for (const item of this.form.mountingsList) {
          item.productType = 1
          item.isParts = 0
        }
        console.log(this.taxRatio)
        if (!isNaN(this.taxRatio)) {
          this.form.mountingsList.forEach((item, index) => {
            this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
          })
        }
        this.calculation()
      }
    },
    handleMountingsLineTemplateDownload() {
      downloadMountingsLineTemplate().then((response) => {
        downloadFile(response)
      })
    },
    // zp03投入导入
    getPutIntoZP03Line(e) {
      if (e.data.length <= 0) {
        this.$message.warning('数据导入失败，请检查数据源')
      } else {
        this.$message.success('数据导入成功')
        this.form.putIntoZP03 = mergeObjectArrayWithoutDuplicates(this.form.putIntoZP03, e.data, 'productCode', 'batch')
        for (const item of this.form.putIntoZP03) {
          item.price = item.taxPrice
          item.partType = 1
        }
        if (!isNaN(this.taxRatio)) {
          this.form.putIntoZP03.forEach((item, index) => {
            this.$set(this.form.putIntoZP03[index], 'taxRatio', this.taxRatio)
          })
        }
      }
    },
    handlePutIntoZP03LineTemplateDownload() {
      downloadPutIntoZP03LineTemplate().then((response) => {
        downloadFile(response)
      })
    },
    // zp09投入导入
    getPutIntoZP09Line(e) {
      if (e.data.length <= 0) {
        this.$message.warning('数据导入失败，请检查数据源')
      } else {
        this.$message.success('数据导入成功')

        this.form.putIntoZP09 = mergeObjectArrayWithoutDuplicates(this.form.putIntoZP09, e.data, 'productCode', 'batch')
        for (const item of this.form.putIntoZP09) {
          item.price = item.taxPrice
          item.partType = 2
        }
        if (!isNaN(this.taxRatio)) {
          this.form.putIntoZP09.forEach((item, index) => {
            this.$set(this.form.putIntoZP09[index], 'taxRatio', this.taxRatio)
          })
        }
      }
    },
    handlePutIntoZP09LineTemplateDownload() {
      downloadPutIntoZP03LineTemplate().then((response) => {
        downloadFile(response)
      })
    },
    // 配件-采购订单
    setPurchase(row, index) {
      this.showObj.purchase = true
      this.purchaseRow = row.crmPurchaseOrderModel ? row.crmPurchaseOrderModel : this.purchaseRow
      this.purchaseIndex = index
      // this.purchaseRow.purchasingOrganizationId = this.form.salesOrganizationId
      this.purchaseRow.supplierId = this.purchaseRow.supplierId || this.supplierOptions[0].value
      this.purchaseRow.purchaseBasicsId = this.purchaseRow.purchaseBasicsId || this.purchaseBasicsOptions[0].value
    },
    purchaseConfirm() {
      this.$refs['purchaseForm'].validate(async (valid, obj) => {
        if (valid) {
          // this.form.mountingsList[this.purchaseIndex].crmPurchaseOrderModel
          this.form.mountingsList[this.purchaseIndex].crmPurchaseOrderModel = this.purchaseRow
          this.purchaseClose()
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    purchaseClose() {
      this.purchaseIndex = null
      this.purchaseRow = {}
      this.showObj.purchase = false
    },
    // 配件-通用物料
    addCommonsLine() {
      if (!this.form.salesOrganizationId || !this.form.channelOfDistributionId || !this.form.productTeamId || !this.form.salesCode) {
        this.$message.warning('请先选择单据类型、销售组织、分销渠道、产品组，再添加订单明细')
        return
      }
      this.showObj.commons = true
      this.getCommons()
    },
    async getCommons(type = '') {
      if (type === 'refresh') {
        this.pagination.commons.current = 1
      }
      this.loadingObj.commons = true
      const reponse = await getCommonssApi(this.condition.commons, this.pagination.commons)
      const { current, total, size, records } = reponse.data
      this.dialog.commons = records
      this.pagination.commons.total = total
      this.pagination.commons.current = current
      this.pagination.commons.size = size
      this.loadingObj.commons = false
    },
    // handleMountingsDelete(index) {
    //   this.form.mountingsList.splice(index, 1)
    // },
    handleCommonsChange(val) {
      this.selection.commons = val
    },
    commonsConfirm() {
      // const arr = JSON.parse(JSON.stringify(this.form.mountingsList))
      // if (arr !== null && arr.length > 0) {
      //   this.form.mountingsList = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
      // } else {
      //   this.form.mountingsList = this.selection.mountings
      // }

      for (const item of this.selection.commons) {
        if (item.id) {
          delete item.id
        }
        item.saleOrderId = this.form.id || null
        item.isPurchase = true
        item.productType = 1
        item.isParts = 0
      }
      this.form.mountingsList = this.form.mountingsList.concat(this.selection.commons)
      console.log(this.form.mountingsList)
      if (!isNaN(this.taxRatio)) {
        this.form.mountingsList.forEach((item, index) => {
          this.$set(this.form.mountingsList[index], 'taxRatio', this.taxRatio)
        })
      }
      this.commonsClose()
    },
    commonsClose() {
      this.showObj.commons = false
    },
    // 基础数据-选择公司
    setCompany() {
      this.showObj.company = true
      this.getCompany()
    },
    async getCompany() {
      this.loadingObj.company = true
      const reponse = await getCompany({}, this.pagination.company)
      const { current, total, size, records } = reponse.data
      this.dialog.company = records
      this.pagination.company.total = total
      this.pagination.company.current = current
      this.pagination.company.size = size
      this.loadingObj.company = false
    },
    handleCompanyChange(val) {
      this.selection.company = val
    },
    companyConfirm() {
      if (this.selection.company.length > 1) {
        this.$message.warning('只能选择一个公司')
      } else {
        this.showObj.company = false
        // this.purchaseRow.
        console.log(this.selection.company)
      }
    },
    companyClose() {
      this.showObj.company = false
    },

    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        console.log(this.form)

        // this.form.mountingsList = []
        // this.form.flotsamList = []
        this.$set(this.form, 'mountingsList', [])
        this.$set(this.form, 'flotsamList', [])
        this.$set(this.form, 'putIntoZP03', [])
        this.$set(this.form, 'putIntoZP09', [])
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId
        console.log(this.form.crmSalesOrdersLineModels)
        if (this.form.crmSalesOrdersLineModels && this.form.crmSalesOrdersLineModels.length > 0) {
          for (const item of this.form.crmSalesOrdersLineModels) {
            item.isPurchase = item.isPurchase === 1
            if (item.productType === 1) {
              this.form.mountingsList.push(item)
            } else {
              this.form.flotsamList.push(item)
            }
          }
        }
        if (this.form.crmSalesOrdersLooseItemsModels && this.form.crmSalesOrdersLooseItemsModels.length > 0) {
          for (const item of this.form.crmSalesOrdersLooseItemsModels) {
            if (item.partType === 1) {
              this.form.putIntoZP03.push(item)
            } else {
              this.form.putIntoZP09.push(item)
            }
          }
        }
        // 获取的时候是null就赋值成配件
        this.form.channelOfDistributionId = this.form.channelOfDistributionId !== null ? this.form.channelOfDistributionId.toString() : '2'

        this.getOptionOrganization(this.form.salesOrganizationId)

        const productTeamId = this.form.productTeamId
        const productTeamOption = await this.getProductTeamOption(this.form.channelOfDistributionId)
        console.log(productTeamOption)
        if (productTeamId) {
          this.form.productTeamId = productTeamId.toString()
        } else {
          this.form.productTeamId = productTeamOption[0].value
        }

        if (this.form.mountingsList.length <= 0 && this.form.flotsamList.length > 0) {
          this.activePaneName = 'flotsam'
        }
        // this.$set(this.form, 'productTeamId', productTeamId)
        this.flowRejectTo(null, null)
        this.loading = false
        // this.$nextTick(() => {
        //   this.$refs.elTable.doLayout()
        // })
      } catch (error) {
        this.loading = false
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    //  选择跟单员
    selectOrderFollower() {
      this.showObj.orderFollower = true
      this.getOrderFollowerDialog()
    },
    async getOrderFollowerDialog(type = '') {
      if (type === 'refresh') {
        this.pagination.orderFollower.current = 1
      }
      this.loadingObj.orderFollower = true
      this.condition.orderFollower
      const { data } = await getFollowerApi({ condition: this.condition.orderFollower, pagination: this.pagination.orderFollower })

      this.dialog.orderFollower = data?.records || []
      this.pagination.orderFollower.total = data?.total || 0
      this.pagination.orderFollower.current = data?.current || 1
      this.pagination.orderFollower.size = data?.size || 20
      this.loadingObj.orderFollower = false
    },
    handleOrderFollowerSelectionChange(val) {
      this.selection.orderFollower = val
    },
    orderFollowerConfirm() {
      if (this.selection.orderFollower.length > 1) {
        this.$message.warning('只能选择一个跟单员！')
      } else {
        console.log(this.selection.orderFollower)
        this.form.orderFollower = this.selection.orderFollower[0].name
        this.orderFollowerClose()
      }
    },
    orderFollowerClose() {
      this.showObj.orderFollower = false
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true
            const formData = JSON.parse(JSON.stringify(this.form))

            // 没有送达方就赋值成售达方
            if (!formData.deliverySideId) {
              formData.deliverySideId = formData.soldToPartyId
              formData.deliverySideName = formData.soldToPartyName
            }
            formData.crmSalesOrdersLineModels = formData.mountingsList.concat(formData.flotsamList)
            formData.crmSalesOrdersLooseItemsModels = formData.putIntoZP03.concat(formData.putIntoZP09)
            if (formData.crmSalesOrdersLineModels.length <= 0) {
              this.$message.warning('订单明细不能为空')
              this.loading = false
              return
            }
            for (const item of formData.crmSalesOrdersLineModels) {
              item.isPurchase = item.isPurchase ? 1 : 2
              if (item.isPurchase === 1) {
                if (!item.crmPurchaseOrderModel || !item.crmPurchaseOrderModel.purchasingOrganizationId || !item.crmPurchaseOrderModel.unitPrice || !item.crmPurchaseOrderModel.qty || !item.crmPurchaseOrderModel.taxCode) {
                  this.$message.warning('请补充完整的采购信息')
                  this.loading = false
                  return
                }
              }
            }

            delete formData.mountingsList
            delete formData.flotsamList
            delete formData.putIntoZP03
            delete formData.putIntoZP09
            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            this.editId = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },
    flowRejectTo(isAssignee, nodeName) {
      console.log(isAssignee, nodeName)
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        console.log(this.form.status)
        if (this.form.status > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      // if (!this.form.flowPathNodePersonModels) {
      //   this.$message({
      //     type: 'warning',
      //     message: '请选择审批人'
      //   })
      //   return
      // }
      // if (this.form.flowPathNodePersonModels.length !== 2) {
      //   this.$message({
      //     type: 'warning',
      //     message: '只能选择两名审批人'
      //   })
      //   return
      // }
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    },
    async submit() {
      try {
        //判断废料销售价格低于公式价，需要录入产值差异原因
        // if(this.form.salesCode === 'ZOR1') {
        //   for (const item of this.form.flotsamList) {
        //     if (item.referencePrice > item.taxPrice && !item.lowPriceReason ) {
        //       this.$message({
        //         type: 'warning',
        //         message: '废料销售价格低于市场价格，需要选择产值差异原因'
        //       })
        //       return
        //     } else if(item.referencePrice > item.taxPrice && item.lowPriceReason === 1 ) {
        //       let queryInfo = {
        //         referenceTable: 'crm_sales_orders_line ',
        //         attribute1: '扣杂凭证',  
        //         intReferenceId: item.id,
        //       }
        //       const { code, data } = await getCommonList(queryInfo)
        //       if(code == 200) {
        //         console.log("进入方法")
        //         if(!data || data.length <= 0) {
        //           this.$message({
        //             type: 'warning',
        //             message: '需要上传质量问题扣杂图片'
        //           })
        //           return;
        //         }
        //       } else {
        //         return;
        //       }
        //     }
        //   }
        // }
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        this.loading = false
        // this.handleClose()
        this.getData()
      } catch (error) {
        this.loading = false
      }
    },
  }
}
</script>
  <style scoped>
/* .dialog{
    height: 60vh;
  } */
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
.selectNone {
  user-select: none;
}
.blueBtn {
  font-size: 12px;
  color: rgb(64, 158, 255);
  margin: 0 2px;
  cursor: pointer;
}
</style>

